import {ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {FormControl, FormGroup} from '@angular/forms';
import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {merge} from 'rxjs/observable/merge';
import {of as observableOf} from 'rxjs/observable/of';
import {catchError} from 'rxjs/operators/catchError';
import {map} from 'rxjs/operators/map';
import {startWith} from 'rxjs/operators/startWith';
import {switchMap} from 'rxjs/operators/switchMap';
import {MatDialog} from '@angular/material';
import {TimerObservable} from 'rxjs/observable/TimerObservable';
import {SaveFilterStateService} from '@app/app/shared/services/save-filter-state.service';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';
import {environment} from '@app/environments/environment';
import {AWSService} from '@app/app/shared/services/aws.service';
import {Subscription} from 'rxjs/Subscription';
import {WebHttpUrlEncodingCodec} from '@app/app/shared/helpers/web.http.url.encoding.codec';
import {CommandsService} from '@app/app/shared/services/commands.service';

@Component({
  moduleId: module.id,
  selector: 'table-sorting-example',
  styleUrls: ['table-sorting-example.css'],
  templateUrl: 'manufacturer.component.html'
})

export class ManufacturerComponent implements OnInit, AfterViewInit, OnDestroy {
  displayedColumns = ['project_id', 'name', 'installation_type', 'country',
    'city', 'state', 'firmware_version', 'comm_manager_version', 'last_connected_at'];

  dataSource = new MatTableDataSource();
  park: any;
  resultsLength = 0;
  isLoadingResults = true;
  name: string;
  query: string;

  flag = 'init';

  filterForm = new FormGroup({
    query: new FormControl(),
    active: new FormControl(),
    installation_type: new FormControl(),
    connect_state: new FormControl(),
  });

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  filter = new Filter();

  group: any;
  included: any;
  allowToAdd = true;
  sub1: Subscription;
  sub2: Subscription;
  sub3: Subscription;

  constructor(private http: HttpClient, private route: ActivatedRoute,
              public dialog: MatDialog, private auth: AuthenticationService,
              private saveFilterStateService: SaveFilterStateService,
              private urlHelper: UrlHelper, private aws: AWSService,
              private commandsService: CommandsService) {
    if (this.auth.userRole() === 'manufacturer') {
      this.allowToAdd = true;
    } else if (this.auth.userRole() === 'client') {
      this.allowToAdd = false;
    } else if (this.auth.userRole() === 'admin') {
      this.allowToAdd = true;
    } else if (this.auth.userRole() === 'employee') {
      this.allowToAdd = false;
    }
  }

  applyFilter(filterValue: string) {
    this.saveFilterStateService.query = filterValue;
    this.filter.change(filterValue);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  public isOnline(splashpad) {
    if (!splashpad.hasOwnProperty('last_connection')) {
      return false;
    }

    if (!splashpad.hasOwnProperty('last_disconnection')) {
      return true;
    }

    return Number.parseInt(splashpad.last_connection) > Number.parseInt(splashpad.last_disconnection);
  }

  public isProvisioning(attributes) {
     if (!attributes.hasOwnProperty('is_connected')) {
      return false;
     }

     return Boolean(attributes.is_connected);
  }

  public isOffline(splashpad) {
    if (!splashpad.hasOwnProperty('last_connection')) {
      return true;
    }

    if (!splashpad.hasOwnProperty('last_disconnection')) {
      return false;
    }

    return Number.parseInt(splashpad.last_connection) <= Number.parseInt(splashpad.last_disconnection);
  }

  isConnected(row) {
    return (this.hasShadowData(row) && this.isOnline(row.attributes.shadow.splashpad))
      || this.isProvisioning(row.attributes);
  }

  isDisconnected(row) {
    return (this.hasShadowData(row) && this.isOffline(row.attributes.shadow.splashpad))
      && !this.isProvisioning(row.attributes);
  }

  lastConnected(row) {
    if (this.hasShadowData(row)) {
      return row.attributes.shadow.splashpad.last_connection || null;
    } else {
      if (row.hasOwnProperty('attributes') && row.attributes.hasOwnProperty('last_connected')) {
        return row.attributes.last_connected;
      }
    }
  }

  private hasShadowData(row) {
    return (
      row.hasOwnProperty('attributes') && row.attributes !== null
      && row.attributes.hasOwnProperty('shadow') && row.attributes.shadow !== null
      && row.attributes.shadow.hasOwnProperty('splashpad') && row.attributes.shadow.splashpad !== null);
  }

  returnFilterState() {
    this.filter.filterValue = this.saveFilterStateService.query;
    this.filter.activeValue = this.saveFilterStateService.active;
    this.filter.stateValue = this.saveFilterStateService.state;
    this.filter.installationTypeValue = this.saveFilterStateService.installation_type;

    const query = this.filter.filterValue;
    const active = this.filter.activeValue;
    const installationType = this.filter.installationTypeValue;
    const connectState = this.filter.stateValue;

    this.filterForm.patchValue({
      query: query,
      active: active,
      installation_type: installationType,
      connect_state: connectState
    });

    this.filter.change(query);
    // this.filter.changeA(active);
  }

  clear() {
    this.filter.reset();
    this.saveFilterStateService.clear();
    this.filterForm.patchValue({
      query: null,
      active: null,
      installation_type: null,
      connect_state: null,
    });
  }

  toggleActive(value) {
    this.saveFilterStateService.active = value;
    this.filter.changeA(value);
  }

  toggleState(value) {
    this.saveFilterStateService.state = value;
    this.filter.changeC(value);
  }

  toggleInstallationType(value) {
    this.saveFilterStateService.installation_type = value;
    this.filter.changeD(value);
  }

  getLocation(id) {
    let loc = {
      attributes: {
        country: 'N/A',
        city: 'N/A'
      }
    };

    this.included.forEach((row: any) => {
      if (row.type === 'Location' && row.id === id) {
        loc = row;
      }
    });

    return loc;
  }

  public objectKeys(object) {
    return Object.keys(object);
  }

  private getData() {
    let sortField = '';

    if ((this.sort.direction === 'asc' || this.sort.direction === 'desc') && this.sort.active) {
      if (this.sort.direction === 'desc') {
        sortField = '-' + this.sort.active;
      } else if (this.sort.direction === 'asc') {
        sortField = this.sort.active;
      }
    }

    const page = this.paginator.pageIndex + 1 || 1;
    const query = this.filter.filterValue || '';
    const active = this.filter.activeValue || '';
    const type = this.filter.installationTypeValue || '';
    const state = this.filter.stateValue || '';

    const params = new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('filter[query]', query)
      .set('page', '' + page)
      .set('sort', sortField)
      .set('filter[type]', type)
      .set('active', active)
      .set('offline', state);

    return this.http.get<any>(`${this.urlHelper.getPrefix()}/parks`, {params: params});
  }

  ngOnDestroy() {
    if (this.sub1) {
      this.sub1.unsubscribe();
    }

    if (this.sub2) {
      this.sub2.unsubscribe();
    }
  }

  reloadData() {
    // this.isLoadingResults = true;

    return this.getData().subscribe(data => {
      // this.isLoadingResults = false;
      this.resultsLength = data.meta.pagination.total;
      this.included = data.included || [];
      this.dataSource.data = data.data;
    });
  }

  ngOnInit() {
    if (this.saveFilterStateService.isDirty()) {
      this.returnFilterState();
    }
    // this.route.queryParams.subscribe(params => {
    //   if (params['flag'] === 'returnBack') {
    //     this.returnFilterState();
    //   }
    // });

    // Run cache refresh each 10 seconds
    this.sub1 = TimerObservable.create(10000, 10000).subscribe(() => {
      this.reloadData();
    });

    // If the user changes the sort order, reset back to the first page.
    this.sub2 = this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    this.sub3 = merge(this.filter.filterApplied, this.sort.sortChange, this.paginator.page).pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;
        return this.getData();
      }),
      map(data => {
        this.isLoadingResults = false;
        this.resultsLength = data.meta.pagination.total;
        this.included = data.included || [];
        return data.data;
      }),
      catchError(() => {
        this.isLoadingResults = false;
        return observableOf([]);
      })
    ).subscribe(data => {
      this.dataSource.data = data;

      this.fetchMeta();
    });
  }

  private fetchMeta() {
    this.dataSource.data.forEach((row: any) => {
      if (row.attributes.park_id !== null) {
        this.commandsService.getMeta(row.id).subscribe(() => {
          //
        }, () => {
          // do nothing
        });
      }
    });
  }
}

export class Filter {
  filterApplied = new EventEmitter();
  filterValue = '';
  activeValue = '';
  stateValue = '';
  installationTypeValue = '';

  reset() {
    this.filterValue = '';
    this.activeValue = '';
    this.installationTypeValue = '';
    this.stateValue = '';
    this.filterApplied.emit();
  }

  change(val: string) {
    this.filterValue = val;
    this.filterApplied.emit();
  }

  changeA(val: string) {
    this.activeValue = val;
    this.filterApplied.emit();
  }

  changeC(val: string) {
    this.stateValue = val;
    this.filterApplied.emit();
  }

  changeD(val: string) {
    this.installationTypeValue = val;
    this.filterApplied.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/manufacturer/manufacturer.component.ts